/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const RsaProductFragment = {
  RsaProduct: gql`
    fragment RsaProductQuery on rsaProduct_Entry {
      styles
      rsaCtaLabel
      rsaCtaLink
      rsaCtaLinkNewTab
      rsaCtaLinkNofollow
      rsaCtaStyle
      rsaCtaTag
      titleHeader
      typeHandle
      rsaDescription
      rsaTitle
      rsaBullets {
        ... on rsaBulletsBlock_Entry {
          bulletItem
        }
      }
      rsaImage {
        url
        ... on images_Asset {
          altText
        }
      }
      rsaImageFooterText
      rsaImageFooterTextShow
    }
  `,
};
